import { render, staticRenderFns } from "./LayoutsButtonsExemploSection.vue?vue&type=template&id=035c91a1"
import script from "./LayoutsButtonsExemploSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsButtonsExemploSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsButtonsExemploSection.vue?vue&type=style&index=0&id=035c91a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports